import axios from "axios";
import apiUrl from "../pages/config";

const BASE_URL = apiUrl;

export default axios.create({
  baseURL: BASE_URL,
});

export const axiosPrivate = axios.create({
  baseURL: BASE_URL,
  headers: { "Content-Type": "application/json" },
  withCredentials: true,
});
